import { render, staticRenderFns } from "./LaporanBukuBesar.vue?vue&type=template&id=4312abc0&"
import script from "./LaporanBukuBesar.vue?vue&type=script&lang=js&"
export * from "./LaporanBukuBesar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports